import { render, staticRenderFns } from "./SetupTournament.vue?vue&type=template&id=8df3609a&scoped=true&"
import script from "./SetupTournament.vue?vue&type=script&lang=js&"
export * from "./SetupTournament.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8df3609a",
  null
  
)

export default component.exports